// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedLinkCard_container__1jScw","content":"RelatedLinkCard_content__2DQeL","text":"RelatedLinkCard_text__1yRqD","coloredDiv":"RelatedLinkCard_coloredDiv__3CYBU"};